// extracted by mini-css-extract-plugin
export default {"error":"error__j6Vo_nzy","errorImage":"errorImage__GEX7nCUO","title":"title__GMhEBCkM","desc":"desc__RLp9Cxt6"};